import React, { useCallback, useState } from "react"
import { TouchableOpacity } from "~/ui/primitives"
import { useTheme } from "~/ui/styled"
import { IconFont } from "~components/El"
import { InputTextFloatLabel } from "~components/input-text"
import { rules } from "~utils/validator"

interface Props {
  label?: string
  value: string
  placeholder?: string
  onChange: (value: string) => void
}

const Password: React.FC<Props> = ({ label = "密码", value, onChange, ...rest }) => {
  const theme = useTheme()
  const [secure, setSecure] = useState(true)

  const toggleSecure = useCallback(() => {
    setSecure((s) => !s)
  }, [])

  const rightAccessory = (
    <TouchableOpacity
      onClick={toggleSecure}
      hitSlop={{ top: 8, bottom: 8, left: 8, right: 8 }}
      accessibilityRole="button"
      accessibilityLabel={secure ? "显示密码" : "隐藏密码"}
    >
      <IconFont
        name={secure ? "xszxzt" : "yincang"}
        size={20}
        color={theme.colors.secondaryText}
      />
    </TouchableOpacity>
  )

  return (
    <InputTextFloatLabel
      label={label}
      secureTextEntry={secure}
      autoCapitalize="none"
      autoCorrect={false}
      textContentType="password"
      autoComplete="new-password"
      placeholder={`请输入${label}`}
      value={value}
      onChangeText={onChange}
      validRule={rules.password}
      rightAccessory={rightAccessory}
      {...rest}
    />
  )
}

export default Password
